/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsAjaxCart = {
  init: function ($section) {
    if (this.ggbInitialized) return;

    // Add settings from schema to current object
    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));
    this.ggbInitialized = true;
    this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click.ggbAjaxCart', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click.ggbAjaxCart', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click.ggbAjaxCart', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

      return false;
    });

    $(document).on('click.ggbAjaxCart', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ggbOpenAfterRefresh = true;
    return this.updateView();
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ggbOpenAfterRefresh = false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
        if (window.PXUTheme.jsCart) window.PXUTheme.jsCart.updateView(cart, lineID);
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {
    return this.updateView();
  },
  initializeAjaxCartOnMobile: function () {
    this.toggleMiniCart();
    return this.updateView();
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              window.PXUTheme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          if (window.PXUTheme.jsAjaxCart.cart_action === 'drawer') {
            window.PXUTheme.jsAjaxCart.showDrawer();
          } else {
            window.PXUTheme.jsAjaxCart.updateView();
          }

          if (window.PXUTheme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {
    const sequence = this.ggbRefreshSequence = (this.ggbRefreshSequence || 0) + 1;
    const cartUrl = window.PXUTheme.routes.cart_url;
    const $content = $('[data-ajax-cart-content]');
    $content.attr('aria-busy', 'true').attr('inert', '');

    // Start a fresh request AFTER each mutation. asyncView.load() can reuse
    // an older in-flight request, including the initial empty cart.
    return $.ajax({
      url: cartUrl,
      data: { view: 'ajax' },
      dataType: 'html',
      cache: false,
      timeout: 15000
    }).then(response => {
      if (sequence !== this.ggbRefreshSequence) return false;

      const fragment = document.createElement('div');
      fragment.innerHTML = response;
      const optionsTemplate = fragment.querySelector('template[data-options]');
      const contentTemplate = fragment.querySelector('template[data-html="content"]');
      if (!optionsTemplate || !contentTemplate) throw new Error('Cart view is unavailable');
      const options = JSON.parse(optionsTemplate.innerHTML);
      if (!Number.isInteger(options.item_count) || options.item_count < 0) {
        throw new Error('Cart count is invalid');
      }

      // Replace the full fragment so empty -> populated -> empty works even
      // when the old drawer has no list or subtotal markup to replace.
      $content.html(contentTemplate.innerHTML).removeAttr('aria-busy inert');
      $('[data-ajax-cart-trigger]').toggleClass('has-cart-count', options.item_count > 0);
      $('[data-bind="itemCount"]').text(options.item_count);
      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
      if (this.ggbOpenAfterRefresh) {
        this.ggbOpenAfterRefresh = false;
        this.ajaxCartDrawer.addClass('is-visible');
        $('.ajax-cart__overlay').addClass('is-visible');
      }
      return true;
    }).fail(() => {
      if (sequence !== this.ggbRefreshSequence) return;
      $content.removeAttr('aria-busy inert');
      // Never repeat a successful add because drawer rendering failed.
      // The normal cart page remains the fallback for an unavailable view.
      if (this.ggbOpenAfterRefresh || this.ajaxCartDrawer.hasClass('is-visible')) {
        this.ggbOpenAfterRefresh = false;
        window.location.assign(cartUrl);
      }
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $(document).off('.ggbAjaxCart');
    this.ggbInitialized = false;
    this.ggbRefreshSequence = (this.ggbRefreshSequence || 0) + 1;
  }
}

/******/ })()
;